import { useFormContext, useWatch } from 'react-hook-form';
import { JobFormValues } from '../components/EditEnrichedVacancyForm/EditEnrichedVacancy.types';

const _sanitizeObject = (obj: Record<string, any>): Record<string, any> => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([, value]) => {
        if (value === undefined || value === null) return false;
        if (typeof value === 'string' && value.trim() === '') return false;
        if (Array.isArray(value) && value.length === 0) return false;
        if (typeof value === 'object' && Object.keys(value).length === 0) return false;
        return true;
      })
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return [key, value.map((v) => (typeof v === 'object' ? _sanitizeObject(v) : v)).filter(Boolean)];
        }
        if (typeof value === 'object' && !Array.isArray(value)) {
          return [key, _sanitizeObject(value)];
        }
        return [key, value];
      })
      .filter(([, value]) => {
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'object') return Object.keys(value).length > 0;
        return true;
      }),
  );
};

export const useCurrentEnrichedFormValues = () => {
  const { control } = useFormContext<JobFormValues>();
  const values = useWatch({ control });

  const getValues = ({ sanitize = false } = {}) => {
    if (!sanitize || !values) return values;
    return _sanitizeObject(values);
  };

  return getValues;
};
